var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4L0 4L0 28L24 28L24 4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 14.9997L10.9999 7.99933L12.9996 7.99933L12.9996 14.9997L20 14.9997V16.9994L12.9996 16.9994L12.9996 23.9997L10.9999 23.9997L10.9999 16.9994L3.9996 16.9994V14.9997L10.9999 14.9997Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.61e9c7a340251242e7ffe0377273d9b3.svg";
export { ForwardRef as ReactComponent };